// Local enviromnent variables to be accessible on angular and react apps

const generateEnv = initState => {
  const env = initState || {}
  env.setItem = (key, value) => (env[key] = value)
  env.getItem = key => env[key]
  return env
}

export const getPublicUrl = (env, ext) => env.getItem('PUBLIC_URL') + '/' + ext

export default generateEnv
